// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    validateRequestedDeliveryDate?: () => boolean;
    validateRequestedPickUpDate?: () => boolean;
    focusRequestedDeliveryDate?: () => void;
    focusRequestedPickUpDate?: () => void;
}>;

export const DispatchSetValidateShippingDates: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/SetValidateShippingDates",
        validateRequestedDeliveryDate: props.parameter.validateRequestedDeliveryDate,
        validateRequestedPickUpDate: props.parameter.validateRequestedPickUpDate,
        focusRequestedDeliveryDate: props.parameter.focusRequestedDeliveryDate,
        focusRequestedPickUpDate: props.parameter.focusRequestedPickUpDate,
    });
};

export const chain = [DispatchSetValidateShippingDates];

const setValidateShippingDates = createHandlerChainRunner(chain, "SetValidateShippingDates");
export default setValidateShippingDates;
